/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { makeStyles } from "../../packages/fluent9";

/**
 * Gets the styles for the Flex component.
 * @returns The styles for the Flex component.
 */
export const useStyles = makeStyles({
    horizontal: {
        flexDirection: "row"
    },
    root: {
        boxSizing: "border-box",
        display: "flex",
        flexWrap: "nowrap",
        height: "auto",
        width: "auto",
        "> *": {
            textOverflow: "ellipsis"
        },
        "> :not(:first-child)": {
            marginTop: "0rem"
        },
        "> *:not(.FlexItem)": {
            flexShrink: 1
        }
    },
    vertical: {
        flexDirection: "column"
    }
});
